// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.footer {
  width: 100%;
  padding: 2rem 0 1.5rem 0;
  text-align: center;
}
.footer__divider {
  width: 85%;
  margin: 0 auto 2rem;
  border: none;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}
.footer__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
.footer__logo {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}
.footer__logo img {
  width: 200px;
  height: 50px;
  object-fit: contain;
}
.footer__logo .footer__brand {
  font-weight: 800;
  color: #1e2150;
  font-size: 1.1rem;
}
.footer__text {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  color: #111827;
  font-size: 0.95rem;
  flex-wrap: wrap;
  justify-content: center;
}
.footer__text a {
  color: #111827;
  text-decoration: none;
  transition: color 0.2s ease;
}
.footer__text a:hover {
  color: #1e2150;
}
.footer__text span {
  opacity: 0.8;
}

/* 🔹 Responsive */
@media (max-width: 768px) {
  .footer__text {
    flex-direction: column;
    gap: 0.3rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/footer.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,WAAA;EACA,wBAAA;EACA,kBAAA;AAAF;AAEE;EACE,UAAA;EACA,mBAAA;EACA,YAAA;EACA,wCAAA;AAAJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAFJ;AAII;EACE,YAAA;EACA,YAAA;EACA,mBAAA;AAFN;AAKI;EACE,gBAAA;EACA,cCjBO;EDkBP,iBAAA;AAHN;AAOE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cCjBG;EDkBH,kBAAA;EACA,eAAA;EACA,uBAAA;AALJ;AAOI;EACE,cCvBC;EDwBD,qBAAA;EACA,2BAAA;AALN;AAOM;EACE,cCrCK;ADgCb;AASI;EACE,YAAA;AAPN;;AAYA,kBAAA;AACA;EACE;IACE,sBAAA;IACA,WAAA;EATF;AACF","sourcesContent":["@use \"variables\" as v;\r\n\r\n.footer {\r\n  width: 100%;\r\n  padding: 2rem 0 1.5rem 0;\r\n  text-align: center;\r\n\r\n  &__divider {\r\n    width: 85%;\r\n    margin: 0 auto 2rem;\r\n    border: none;\r\n    border-top: 1px solid rgba(0, 0, 0, 0.2);\r\n  }\r\n\r\n  &__content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 1rem;\r\n  }\r\n\r\n  &__logo {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.6rem;\r\n\r\n    img {\r\n      width: 200px;\r\n      height: 50px;\r\n      object-fit: contain;\r\n    }\r\n\r\n    .footer__brand {\r\n      font-weight: 800;\r\n      color: v.$brand-blue;\r\n      font-size: 1.1rem;\r\n    }\r\n  }\r\n\r\n  &__text {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.6rem;\r\n    color: v.$dark;\r\n    font-size: 0.95rem;\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n\r\n    a {\r\n      color: v.$dark;\r\n      text-decoration: none;\r\n      transition: color 0.2s ease;\r\n\r\n      &:hover {\r\n        color: v.$brand-blue;\r\n      }\r\n    }\r\n\r\n    span {\r\n      opacity: 0.8;\r\n    }\r\n  }\r\n}\r\n\r\n/* 🔹 Responsive */\r\n@media (max-width: 768px) {\r\n  .footer__text {\r\n    flex-direction: column;\r\n    gap: 0.3rem;\r\n\r\n  }\r\n\r\n\r\n}\r\n","// =========================\r\n// Typography\r\n// =========================\r\n$font-base: \"Noto Sans Armenian\",\r\n-apple-system,\r\nBlinkMacSystemFont,\r\n\"Segoe UI\",\r\nRoboto,\r\nOxygen,\r\nUbuntu,\r\nCantarell,\r\n\"Helvetica Neue\",\r\nsans-serif;\r\n\r\n// =========================\r\n// Brand Colors\r\n// =========================\r\n$brand-blue: #1e2150;\r\n$brand-green: #9eba44;\r\n\r\n// Base Colors\r\n$primary: $brand-blue;\r\n$secondary: $brand-green;\r\n$accent: #facc15;\r\n\r\n$light: #ffffff;\r\n$dark: #111827;\r\n$gray: #6b7280;\r\n$text-muted: #555;\r\n\r\n// Backgrounds\r\n$bg-light: #f9fafb;\r\n$bg-alt: #f0f0f5;\r\n$bg-gray: #f6f6f6;\r\n\r\n// Layout\r\n$max-width: 1400px;\r\n$layout-padding-x: 70px;\r\n\r\n// Spacing\r\n$spacing-xs: 0.25rem;\r\n$spacing-sm: 0.5rem;\r\n$spacing-md: 1rem;\r\n$spacing-lg: 2rem;\r\n$spacing-xl: 4rem;\r\n\r\n// Radius\r\n$radius-xs: 4px;\r\n$radius-sm: 8px;\r\n$radius-md: 12px;\r\n$radius-lg: 20px;\r\n$radius-round: 999px;\r\n\r\n// Shadows\r\n$shadow-medium: 0 4px 18px rgba(0, 0, 0, 0.15);\r\n\r\n// Transitions\r\n$transition-fast: 0.2s;\r\n$transition-normal: 0.3s;\r\n$transition-slow: 0.5s;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
